import { Button, PageHeader, TOUCH } from "@nymbl/nos2-rules";
import { X } from "lucide-react";
// src/components/team/PtoRequestsDialog.tsx
import { PtoRequestList } from "@/components/team/PtoRequestList";
import type { PtoRequestListState } from "@/hooks/use-pto-request-list";
import { useApprovePto, useBookPto, useRejectPto } from "@/hooks/use-team";
import type { PtoTab } from "@/lib/enums";
import type { PtoRequestsView } from "@/schemas/team";

interface PtoRequestsPageProps {
  onClose: () => void;
  /** Owned by My Team, so held rows stay held across close and reopen. */
  state: PtoRequestListState;
  tab: PtoTab;
  onTabChange: (tab: PtoTab) => void;
  view: PtoRequestsView | undefined;
  /** When `view` was read; a row held after a 504 is released by a newer read. */
  viewUpdatedAt: number;
  isError: boolean;
  onRetry: () => void;
}

/** My Team's PTO requests page: direct reports only, decisions with scope "team". */
export function PtoRequestsPage({
  onClose,
  state,
  tab,
  onTabChange,
  view,
  viewUpdatedAt,
  isError,
  onRetry,
}: PtoRequestsPageProps) {
  const approve = useApprovePto();
  const book = useBookPto();
  const reject = useRejectPto();
  return (
    <div className="flex w-full flex-col gap-4">
      <PageHeader
        title="Team PTO requests"
        actions={
          <Button variant="outline" className={TOUCH} onClick={onClose}>
            <X aria-hidden="true" />
            Close
          </Button>
        }
      />
      <PtoRequestList
        view={view}
        viewUpdatedAt={viewUpdatedAt}
        isError={isError}
        onRetry={onRetry}
        tab={tab}
        onTabChange={onTabChange}
        state={state}
        calls={{
          approve: (id) => approve.mutateAsync({ requestId: id }),
          book: (id) => book.mutateAsync({ requestId: id }),
          reject: (id, note) => reject.mutateAsync({ requestId: id, note }),
        }}
      />
    </div>
  );
}
